import React from 'react';

const HowToPrepare = () => {

    return (<div style={{fontSize: '12px'}} id={'how_to_prepare'}>
                Даю згоду на обробку своїх персональних даних, відповідно до Закону України «Про захист персональних даних», з первинних джерел у такому обсязі: паспортні дані, дані про зареєстроване або фактичне місце проживання, номери телефонів, в тому числі використання персональних даних відповідно до їх професійних чи службових або трудових обов’язків, а також дії щодо надання часткового або повного права обробки персональних даних іншим суб’єктам відносин, пов’язаних із персональними даними.

                Мої персональні дані, на обробку яких я даю цю згоду, можуть бути передані третім особам тільки у випадках, передбачених законодавством України.
    </div>);
};

export default HowToPrepare;
